import { TranslationService } from "./services/translation.service";
import { BrowserModule } from "@angular/platform-browser";
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  APP_INITIALIZER,
} from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import {
  TranslateModule,
  TranslateLoader,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";

// import { TranslatePipe } from './pipes/translate.pipe';
import { NgxSpinnerModule } from "ngx-spinner";
import { AppComponent } from "./app.component";

import { CommonModule } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { ToastrModule } from "ngx-toastr";
import { MaterialModule } from "./material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppConfig } from "./app.config";
import { environment } from "src/environments/environment";
import { SetTokenInterceptorService } from "./services/set-token-intercepter.service";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { RootComponent } from "./root/root.component";
import { HistoryComponent } from "./components/history/history.component";
import { AllurecareFormComponent } from "./components/allurecare-form/allurecare-form.component";
import { VehicleInfoComponent } from "./components/vehicle-info/vehicle-info.component";
import { VinSearchBoxComponent } from "./components/vin-search-box/vin-search-box.component";
import { ErrorDialogComponent } from "./components/error-dialog/error-dialog.component";
import { MatDialogModule } from "@angular/material/dialog";
import { StatusMessageComponent } from "./components/status-message/status-message.component";
import { OAuthModule } from "angular-oauth2-oidc";
import { CustomTranslateLoader } from "./utils/CustomTranslateLoader";
import { SubmissionHistoryComponent } from "./components/submission-history/submission-history.component";

// export function HttpLoaderFactory(http: HttpClient) {
//   return new TranslateHttpLoader(http, './assets/i18n/', '.json');
// }

export function HttpLoaderFactory(http: HttpClient) {
  return new CustomTranslateLoader(http, "./assets/i18n/", ".json");
}

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load(environment.configFile);
}
@NgModule({
  declarations: [
    AppComponent,
    RootComponent,
    HistoryComponent,
    AllurecareFormComponent,
    VehicleInfoComponent,
    VinSearchBoxComponent,
    ErrorDialogComponent,
    StatusMessageComponent,
    SubmissionHistoryComponent,
  ],
  entryComponents: [ErrorDialogComponent],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    MaterialModule,
    ScrollingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgxSpinnerModule,
    ToastrModule.forRoot({
      timeOut: 5000,
    }),
    OAuthModule.forRoot(),
    MatDialogModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetTokenInterceptorService,
      multi: true,
    },
    AppConfig,
    // TranslationService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true,
    },
  ],
  bootstrap: [RootComponent],
})
export class AppModule {
  constructor(private translate: TranslateService) {
    translate.setDefaultLang("en");
    // Optionally: translate.use('en');
  }
}
